<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl" scrollable)
    v-card
      v-card-title.px-4
        v-spacer
        .text-lg.font-bold Redeem offer
        v-spacer
      v-divider
      v-card-text.py-6.px-8
        template(v-if="step === 0")
          redeem-offer-list(v-model="selectedOffer" :customer.sync="selectedCustomer" :lead-id="leadId" :customerSelectable="customerSelectable" :disabled="disabled")
        template(v-if="step === 1")
          redeem-verification-code(v-model="otp")
        template(v-if="step === 2")
          redeem-offer-finish(:customer="selectedCustomer" :selected-offer="selectedOffer")
      v-divider
      v-card-actions.px-6
        v-spacer
        v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
        v-btn.button-md.neutral700.white--text(v-if="step === 2" depressed @click="closeDialog") {{ $t('finish') }}
        v-btn.button-md.neutral700.white--text(v-else :loading="isLoading" depressed :disabled="isDisabledContinue" @click="handleContinue") {{ $t('continue') }}
</template>

<script>
import clone from "just-clone";
import {mapActions, mapGetters} from "vuex";
import RedeemOfferList from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferList.vue";
import RedeemOfferOne from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferOne.vue";
import RedeemVerificationCode from "@/components/clinic/checkout/marketing/redeem/RedeemVerificationCode.vue";
import RedeemOfferFinish from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferFinish.vue";


export default {
  components: {
    RedeemOfferFinish,
    RedeemVerificationCode,
    RedeemOfferOne,
    RedeemOfferList,
  },
  props: {
    open: {
      type: Boolean,
    },
    customer: {
      type: Object,
      default: null
    },
    leadId: {
      type: Number,
      default: null
    },
    customerSelectable: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableText: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      step: 0,
      otp: null,
      isLoading: false,
      selectedOffer: null,
      selectedCustomer: null,
    }
  },
  mounted() {
    if (this.customer) {
      this.selectedCustomer = clone(this.customer)
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isDisabledContinue () {
      if (this.step === 0) {
        return !this.selectedOffer
      }
      if (this.step === 1) {
        return !this.otp || this.otp.toString().length !== 4
      }
      return false
    },
    otpRequestPayload() {
      return {
        phone: this.customer.phone,
      }
    },
    otpCheckPayload() {
      return {
        phone: this.customer.phone,
        otp: `${this.otp}`
      }
    },
    redeemOfferPayload() {
      const payload = {
        coupon: this.selectedOffer.id
      }
      if (this.leadId) {
        payload.lead = this.leadId
      }
      return payload
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog() {
      this.showDialog = false
    },
    async handleContinue() {
      if (this.disabled) {
        this.showMessage(['error', this.disableText || 'You cannot redeem offers at the moment.'])
        return
      }
      if (this.step === 0) {
        const requested = await this.requestOTP()
        if (!requested) return
        this.step = 1
        return
      }
      if (this.step === 1) {
        const isValidOTP = await this.checkOTP()
        if (!isValidOTP) return
        const redeemed = await this.redeemOffer()
        if (!redeemed) return
        this.handleUpdated()
        this.step = 2
      }
    },
    async requestOTP() {
      try {
        this.isLoading = true
        const url = `/marketing/${this.company.slug}/redeems/request_otp`
        const { data } = await this.$axios.post(url, this.otpRequestPayload)
        this.updateActivityLog(url, this.otpRequestPayload, data, 'POST', 'Redeem offer request OTP', null)
        return true
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return false
      } finally {
        this.isLoading = false
      }
    },
    async checkOTP() {
      const url = `/marketing/${this.company.slug}/redeems/check_otp`
      try {
        this.isLoading = true
        const { data } = await this.$axios.post(url, this.otpCheckPayload)
        this.updateActivityLog(url, this.otpCheckPayload, data, 'POST', 'Redeem offer check OTP - success', null)
        return true
      } catch (error) {
        if (error.response.status === 400) {
          this.updateActivityLog(url, this.otpCheckPayload, error.response.data, 'POST', 'Redeem offer check OTP - invalid TAC', null)
          this.showMessage(['error', 'Invalid TAC'])
        } else {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }
        return false
      } finally {
        this.isLoading = false
      }
    },
    async redeemOffer() {
      try {
        const url = `/marketing/${this.company.slug}/redeems`
        const { data } = await this.$axios.post(url, this.redeemOfferPayload)
        this.updateActivityLog(url, this.redeemOfferPayload, data, 'POST', 'Redeem offer', data.id)
        return true
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return false
      }
    },
    updateActivityLog (endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'OTP',
        activity: activity,
        raw_data: { endpoint, payload, response: response, method}
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {})
    },
    handleUpdated() {
      this.$emit('updated')
    }
  },
}
</script>

<style scoped>
</style>